import { useState } from 'react';
import { AxiosPrivate } from '../utils/axios';

export const useGetAllUsers = () => {
  const [isFetching, setFetching] = useState(false);
  const [allUsers, setAllUsers] = useState<any[]>([]);

  return {
    allUsers,
    isFetching,
    onLoad: async () => {
      try {
        setFetching(true);
        const { data } = await AxiosPrivate.get(`/users?orderBy=firstName&order=ASC`);

        setAllUsers(data);
        setFetching(false);
      } catch (e) {
        setFetching(false);
      }
    },
  };
};
